import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, object=user
  const [notifs, setNotifs] = useState({ notifications: [], unread: 0 });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      return data.user;
    } catch {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const loadNotifs = useCallback(async () => {
    if (!user) return;
    try { const { data } = await api.get("/notifications"); setNotifs(data); } catch {}
  }, [user]);

  useEffect(() => {
    if (!user) return;
    loadNotifs();
    const t = setInterval(loadNotifs, 20000);
    return () => clearInterval(t);
  }, [user, loadNotifs]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("jx_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, display_name) => {
    const { data } = await api.post("/auth/register", { email, password, display_name });
    if (data.token) localStorage.setItem("jx_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("jx_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, refresh, notifs, loadNotifs }}>
      {children}
    </AuthContext.Provider>
  );
}
